.chart {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: 0;
  margin: 0;
  list-style: none;
}

.row {
  display: block;
}

.hit {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: var(--space-1) var(--space-3);
  align-items: baseline;
  width: 100%;
  padding: var(--space-2);
  border: none;
  border-radius: var(--radius-sm);
  background: none;
  text-align: left;
  cursor: default;
}

button.hit {
  cursor: pointer;
}

button.hit:hover,
button.hit[aria-expanded="true"] {
  background: var(--surface-sunken);
}

.label {
  overflow: hidden;
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  color: var(--text-primary);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.figures {
  font-size: var(--text-sm);
  color: var(--text-secondary);
  white-space: nowrap;
}

.track {
  position: relative;
  grid-column: 1 / -1;
  height: var(--space-2);
  border-radius: var(--radius-full);
  background: var(--surface-sunken);
}

.bar {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  border-radius: var(--radius-full);
  transition: width var(--duration-base) var(--ease-out);
}

/* Colour reinforces the verdict the length already gives; the figures and the
   meta sentence beside it are what actually say it. */
.untargeted {
  background: var(--budget-untargeted);
}

.spare {
  background: var(--budget-spare);
}

.onTrack {
  background: var(--budget-on-track);
}

.nearMiss {
  background: var(--budget-near-miss);
}

.missed {
  background: var(--budget-missed);
}

/* The target, as a rule line rather than a second competing colour. */
.rule {
  position: absolute;
  top: calc(var(--space-1) * -0.5);
  bottom: calc(var(--space-1) * -0.5);
  width: 2px;
  border-radius: var(--radius-full);
  background: var(--text-secondary);
}

.meta {
  grid-column: 1 / -1;
  font-size: var(--text-xs);
  color: var(--text-muted);
}

.metaNearMiss {
  color: var(--budget-near-miss);
}

.metaMissed {
  color: var(--budget-missed);
}

/* Indented under the bar it belongs to, so a long list still reads as part of
   that row rather than as the next one. */
.panel {
  padding: var(--space-2) 0 var(--space-3) var(--space-2);
  margin-left: var(--space-2);
  border-left: 2px solid var(--border);
}

.empty {
  padding: var(--space-4) 0;
  font-size: var(--text-sm);
  color: var(--text-muted);
}

@media (prefers-reduced-motion: reduce) {
  .bar {
    transition: none;
  }
}
